import {
  FeatureFlagManager,
  FeatureFlagName,
  FlagConfiguration,
} from "../../config/FeatureFlagManager/FeatureFlagManager.ts";
import { Button } from "../../ui-library/Button/Button.tsx";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "../../ui-library/Dialog";
import styles from "./LabsModal.module.css";

export const LabsModal: React.FC<{
  open: boolean;
  onClose: () => void;
  featureFlagManager: FeatureFlagManager;
  featureList: FlagConfiguration[];
}> = ({ open, onClose, featureFlagManager, featureList }) => {
  const handleCheckboxChange = (flag: FeatureFlagName, value: boolean) => {
    featureFlagManager.setConfig(flag, value);
  };

  return (
    <Dialog open={open} onClose={onClose} size="large">
      <DialogHeader title="Experimental Features" onClose={onClose} />
      <DialogContent>
        <p>
          These features are experimental and may not be fully functional. Use
          at your own risk.
        </p>
        <p>
          <em>
            (Changes are saved locally to this browser and will not affect
            sessions in other browsers or devices.)
          </em>
        </p>
        <div className={styles.featureList}>
          {featureList.map((feature) => (
            <div key={feature.flag} className={styles.featureItem}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={feature.value}
                  onChange={(e) =>
                    handleCheckboxChange(feature.flag, e.target.checked)
                  }
                />
                <div>
                  <strong>{feature.name}</strong>
                  <p>{feature.description}</p>
                </div>
              </label>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogFooter align="left">
        <Button
          onClick={featureFlagManager.resetDefaults}
          variant="transparent"
        >
          Reset defaults
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
